export default {
  SET_PERSONALIZACION(state, payload) {
    state.colores = payload.colores;
    state.menu = payload.menu;
    state.empresa = payload.empresa || '0';
    state.ingreso = { ...state.ingreso, ...payload.ingreso };
    state.general = payload.general;
  }
};
